<template>
  <div class="newsdetail">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a :href="'/#/'">
            <i class="fa fa-home"></i>Home
          </a>
        </li>
        <li class="breadcrumb-item">
          <a :href="'/#/newslist/'+this.listName">{{listName}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{dutyTitle}}</li>
      </ol>
    </nav>
    <div class="card news-detail">
      <div class="card-header">
        <div class="card-title">
          <span v-html="dutyTitle"></span>
          <div class="text-sm mt-10 text-muted"><span v-html="dutyCreated"></span></div>
        </div>
      </div>
      <div class="card-body">
        <span v-html="dutyDetail"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsDetail',
  data: () => ({
    site: '',
    listName: '',
    titleName: '',
    dutyTitle: '',
    dutyCreated: '',
    dutyDetail: ''
  }),
  created () {
    this.listName = this.$route.params.name
    this.titleName = this.$route.params.title
    this.site = this.GLOBAL.sharepoint['pilotportalsite_id']
    this.getDutyDetail(localStorage.getItem('access_token'), this.listName, this.titleName)
      .then(resp => {
        if (resp.data.value[0] === undefined & this.titleName.indexOf('<->') >= 0) {
          var restruct = this.titleName.split('<->')[1] + '<->' + this.titleName.split('<->')[0]
          this.getDutyDetail(localStorage.getItem('access_token'), this.listName, restruct)
            .then(resp => {
              this.dutyTitle = resp.data.value[0].fields.Title
              this.dutyCreated = this.$moment(resp.data.value[0].fields.Created).format('YYYY-MM-DD HH:mm:ss')
              this.dutyDetail = resp.data.value[0].fields.Body.replace(new RegExp('"/sites/CrewPortal', 'g'), '"https://starluxairlines.sharepoint.com/sites/CrewPortal')
            })
            .catch(err => {
              console.log('err', err)
            })
        } else {
          this.dutyTitle = resp.data.value[0].fields.Title
          this.dutyCreated = this.$moment(resp.data.value[0].fields.Created).format('YYYY-MM-DD HH:mm:ss')
          this.dutyDetail = resp.data.value[0].fields.Body.replace(new RegExp('"/sites/CrewPortal', 'g'), '"https://starluxairlines.sharepoint.com/sites/CrewPortal')
        }
      })
      .catch(err => {
        console.log('err', err)
      })
  }
}
</script>
